export default "__VITE_ASSET__CFbjojzM__"